import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from "styled-components";
import { format as formatDate } from 'date-fns';
import Calendar from 'react-calendar';

import { ReactComponent as CloseIcon } from './close-icon.svg';

import 'react-calendar/dist/Calendar.css';

import './styles.css';

import { FormFieldStyles } from '../Layout';

const Container = styled.div`
  position: relative;
`;

const ClearControl = styled.div`
  position: absolute;
  right: 5px;
  top: calc(50% - 15px);
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0.7;

  svg {
    height: 10px;
    width: 10px;
  }
`;

interface InputProps {
  error: boolean;
}

const Input = styled.input<InputProps>`
  ${FormFieldStyles};
  ${({ error }) => error && css`
    border-color: red;
  `};
`;

const CalendarContainer = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  z-index: 100;
`;

interface OwnProps {
  id?: string;
  value: Date | null;
  placehoder?: string;
  error?: boolean;
  containerStyle?: React.CSSProperties;
  onValueChange: (value: Date | null) => void;
}

type Props = OwnProps;

export default function DateField(props: Props) {
  const { id, value, onValueChange, placehoder, error = false } = props;

  const containerRef = useRef<HTMLInputElement | null>(null);

  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const toggleCalendar = (val?: boolean) => {
    setIsCalendarOpen(val != undefined ? val : !isCalendarOpen);
  };

  const onInputFocus = (evt: React.FocusEvent<HTMLInputElement>) => {
    evt.nativeEvent.stopPropagation();
    setIsCalendarOpen(true);
  };

  const handleClickAway = (evt: MouseEvent) => {
    const el: any = containerRef.current;
    if (el && !el.contains(evt.target)) {
      setIsCalendarOpen(false);
    }
  };


  const calendarOnChange = (value: Date | Date[]) => {
    onValueChange(value as Date);
    setIsCalendarOpen(false);
  };

  const clearControlHandler = () => {
    onValueChange(null);
    setIsCalendarOpen(false);
  };

  useEffect(() => {
    document.addEventListener('click', handleClickAway, false);

    return () => document.removeEventListener('click', handleClickAway, false);
  }, []);

  let formattedDate = '';
  if (value) {
    formattedDate = formatDate(value, 'dd-MM-yyyy')
  }

  return (
    <Container ref={containerRef}>
      {value && (
        <ClearControl onClick={clearControlHandler}>
          <CloseIcon />
        </ClearControl>
      )}

      <Input
        autoComplete="off"
        id={id}
        value={formattedDate}
        placeholder={placehoder || 'Select date'}
        onFocus={onInputFocus}
        error={error}
      />

      {isCalendarOpen && (
        <CalendarContainer>
          <Calendar
            calendarType="US"
            view={'month'}
            next2Label={null}
            prev2Label={null}
            value={value}
            onChange={calendarOnChange}
          />
        </CalendarContainer>
      )}
    </Container>
  );
}